import { AxiosClientFactory } from '../../../common/helpers/AxiosClientFactory';
import { CommandResult } from '../../../common/helpers/CommandResult';

export const deleteApplication = async (personId: string | number, loanId: string | number): Promise<CommandResult> => {
    const result = await AxiosClientFactory
        .getInstance()
        .delete(`api/applicants/${personId}/consumerloans/${loanId}`);

    return new CommandResult(result);
};
